import { categories } from '@/mocks/categories';

export default function CategorySection() {
  return (
    <section className="py-16 md:py-24 px-4 md:px-6 lg:px-10 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full border border-background-300/60 bg-background-50 text-xs font-semibold text-foreground-500 uppercase tracking-wider mb-5 whitespace-nowrap">
            14 Categories
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold font-heading text-foreground-950 leading-tight">
            Browse Product Categories
          </h2>
          <p className="mt-4 text-base text-foreground-500 max-w-lg mx-auto">
            Explore our complete range of sourcing categories — click any category to start browsing products on KA Spreadsheet.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col bg-white rounded-2xl border border-background-200/60 overflow-hidden hover:border-primary-200 hover:shadow-lg transition-all duration-300 cursor-pointer"
            >
              <div className="aspect-[3/2] overflow-hidden">
                <img
                  src={cat.image}
                  alt={`${cat.name} category`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-4 flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-100 group-hover:bg-primary-100 transition-colors duration-300">
                    <i className={`${cat.icon} text-foreground-600 group-hover:text-primary-600 text-sm`}></i>
                  </span>
                  <div>
                    <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-700 transition-colors duration-300 whitespace-nowrap">
                      {cat.name}
                    </h3>
                    <p className="text-xs text-foreground-400 mt-0.5">
                      Browse collection
                    </p>
                  </div>
                </div>
                <span className="w-6 h-6 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-300 translate-x-[-4px] group-hover:translate-x-0 flex-shrink-0">
                  <i className="ri-arrow-right-up-line text-sm text-primary-500"></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}